import PayPalLogo from './paypal_logo'
import { connect } from 'react-redux'

const mapStateToProps = (state, props) => {
  return {
    paypalDomain: state.geo.paypalDomain,
  }
}

export default connect(mapStateToProps)(PayPalLogo)
